{
  "noDataTitle": "No data found",
  "noDataBody": "No answers were collected for this question in the selected timeframe. Verify your timeframe and ensure this type of data is collected in your form."
}
